import React from 'react';
import { motion } from 'framer-motion';
import { FaCheck } from 'react-icons/fa';

const IndustryCard = ({ industry, index }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.5, delay: index * 0.1 }}
      className="group bg-white rounded-2xl overflow-hidden shadow-lg border border-gray-100 hover:shadow-2xl transition-all duration-300 flex flex-col h-full"
    >
      <div className="relative h-48 overflow-hidden">
        <div className="absolute inset-0 bg-gray-900/10 group-hover:bg-gray-900/0 transition-colors z-10" />
        <img
          src={industry.image}
          alt={industry.title}
          className="w-full h-full object-cover transform group-hover:scale-110 transition-transform duration-700"
        />
        <div className="absolute top-4 left-4 z-20 bg-white/90 backdrop-blur-sm p-3 rounded-xl shadow-sm text-purple-600">
          <span className="text-xl">{industry.icon}</span>
        </div>
      </div>
      
      <div className="p-6 flex-1 flex flex-col">
        <h3 className="text-2xl font-bold text-gray-900 mb-3 group-hover:text-purple-700 transition-colors">
          {industry.title}
        </h3>
        <p className="text-gray-600 mb-6 text-sm flex-grow">
          {industry.description}
        </p>
        
        <div className="space-y-3 mt-auto">
          {industry.services.map((service, idx) => (
            <div key={idx} className="flex items-start gap-3">
              <span className="flex-shrink-0 mt-1 w-5 h-5 rounded-full bg-purple-100 text-purple-600 flex items-center justify-center text-xs">
                <FaCheck />
              </span>
              <span className="text-gray-700 text-sm font-medium">{service}</span>
            </div>
          ))}
        </div>
      </div>
    </motion.div>
  );
};

export default IndustryCard;
